// extracted by mini-css-extract-plugin
module.exports = {"DepartmentDashboard":"DepartmentDashboard_DepartmentDashboard__33WOf","Title":"DepartmentDashboard_Title__2_4qB","Worklists":"DepartmentDashboard_Worklists__3oCSi"};